/**
 * As duas decisões do divisor que valem testar, fora do componente.
 *
 * Mesmo padrão de `tree-nodes.ts` e `attribute-set.ts`: o que é regra vira
 * função pura, testável sem TestBed; o componente fica só com o desenho.
 *
 * As duas erram em silêncio — uma linha sai cheia quando devia sair tracejada,
 * uma cor sai neutra quando devia sair de erro. Nada estoura, e ninguém liga o
 * sintoma à causa.
 */
import { DividerProps } from '../../model/node-props';

/** O papel da cor → o token que o tema resolve. */
const COLOR_TOKEN: Readonly<Record<string, string>> = {
  default: 'var(--tem-border)',
  muted: 'var(--tem-muted)',
  strong: 'var(--tem-ink)',
  accent: 'var(--tem-accent)',
  success: 'var(--tem-success)',
  warning: 'var(--tem-warn)',
  danger: 'var(--tem-danger)'
};

/**
 * O traço da linha, em `border-style`.
 *
 * `variant` é o campo novo; `dashed` é o antigo, booleano, e é o único que as
 * telas já gravadas têm. Ignorá-lo mudaria a aparência de tela publicada, então
 * ele continua valendo enquanto ninguém escolher o novo.
 */
export function dividerLineStyle(props: DividerProps): string {
  if (props.variant === 'dashed' || props.variant === 'dotted' || props.variant === 'solid') {
    return props.variant;
  }

  return props.dashed === true ? 'dashed' : 'solid';
}

/**
 * A cor, sempre como token.
 *
 * Um papel desconhecido — vindo do editor de JSON, por exemplo — cai no padrão
 * em vez de virar `undefined` e apagar a borda: divisor invisível é pior que
 * divisor da cor errada.
 */
export function dividerColorToken(props: DividerProps): string {
  const papel = props.color ?? 'default';

  return COLOR_TOKEN[papel] ?? COLOR_TOKEN['default'];
}
